export default "__VITE_ASSET__8C1qnE$4__"